import React from "react";
import "./loadingStyle.css";

const Loader = ({ layoutLoader }) => {
  /* layoutLoader = route/page loading: show only over content area (right side), not full gray screen */
  if (layoutLoader) {
    return <div className="loading-content" aria-hidden="true">Loading&#8230;</div>;
  }
  /* Auth loading: full-screen overlay */
  return <div className="loading">Loading&#8230;</div>;
};

export const LoaderABS = (props) => {
  return <div className="loading-absolute">Loading&#8230;</div>;
};

export default Loader;
